var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('header-name',[_vm._v("Stock Transfer")]),_vm._v(" "),_c('stock-transfer-form',{attrs:{"transfer-stock-route-name":"stock-transfer.transfer"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }